import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { LoginService } from '../services/login.service';
import { User } from '../models/user';
import { DeviceService } from '../services/device.service';
import { TrackerService } from '../services/tracker.service';
import { DeviceColumnService } from '../services/device-column.service';
import { QueryParserService } from '../services/query-parser.service';
import { AutomationService } from '../services/automation.service';
import { CommonService } from '../services/common.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Renderer2 } from '@angular/core';
import { ElementRef } from '@angular/core';
import { EncryptionDecryptionService } from '../services/encryption-decryption.service';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DeviceListDetailsComponent } from './device-list-details/device-list-details.component';
import { DeviceListIconsComponent } from './device-list-icons/device-list-icons.component';

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, DeviceListDetailsComponent, DeviceListIconsComponent]
})
export class DevicesComponent implements OnDestroy, OnInit, AfterViewInit {
  @ViewChild('alertTemplate') alertTemplate: TemplateRef<any>;
  @ViewChild('masterSlaveConfigTemplate') masterSlaveConfigTemplate: TemplateRef<any>;
  modalRef!: MatDialogRef<any>;
  // Selected devices for configuration
  selectedMaster: any | null = null;
  selectedSlaves: (any | null)[] = [null, null, null, null];

  // Validation message
  validationMessage: string = '';

  // Current configuration - to store the existing setup
  currentConfiguration: {
    master: any | null,
    slaves: any[]
  } = {
      master: null,
      slaves: []
    };
  devices = [];
  masterDevice: any = null;
  slaveDevices: any[] = [];
  maxSlaves = 4;
  activeTab: string = 'devices'; //default to devices
  columns: any
  currentUser: User;
  columnDefinitions: any;
  mapping = Object.create(null);
  // @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();
  oldPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  showCols: boolean = false;
  totalDeviceCount: any = 0;
  usableDeviceCount: any = 0;
  busyDeviceCount: any = 0;
  currentUserUsingDevice: any = 0;
  searchDetails = {
    deviceFilterdetails: '',
    focusElement: false
  };
  searchDevices = {
    deviceFilterdevices: '',
    focusElement: false
  };
  packageName: string;


  defaultColumns = [
    {
      name: 'state'
      , selected: true
    }
    , {
      name: 'model'
      , selected: true
    }
    , {
      name: 'name'
      , selected: true
    }
    , {
      name: 'serial'
      , selected: true
    }
    , {
      name: 'operator'
      , selected: false
    }
    , {
      name: 'releasedAt'
      , selected: false
    }
    , {
      name: 'version'
      , selected: true
    }
    , {
      name: 'network'
      , selected: false
    }
    , {
      name: 'display'
      , selected: false
    }
    , {
      name: 'manufacturer'
      , selected: false
    }
    , {
      name: 'marketName'
      , selected: false
    }
    , {
      name: 'sdk'
      , selected: false
    }
    , {
      name: 'abi'
      , selected: false
    }
    , {
      name: 'cpuPlatform'
      , selected: false
    }
    , {
      name: 'openGLESVersion'
      , selected: false
    }
    , {
      name: 'browser'
      , selected: false
    }
    , {
      name: 'phone'
      , selected: false
    }
    , {
      name: 'imei'
      , selected: false
    }
    , {
      name: 'imsi'
      , selected: false
    }
    , {
      name: 'iccid'
      , selected: false
    }
    , {
      name: 'batteryHealth'
      , selected: false
    }
    , {
      name: 'batterySource'
      , selected: false
    }
    , {
      name: 'batteryStatus'
      , selected: false
    }
    , {
      name: 'batteryLevel'
      , selected: true
    }
    , {
      name: 'batteryTemp'
      , selected: false
    }
    , {
      name: 'provider'
      , selected: true
    }
    , {
      name: 'notes'
      , selected: true
    }
    , {
      name: 'owner'
      , selected: true
    }
    , {
      name: 'group'
      , selected: true
    }
    , {
      name: 'groupSchedule'
      , selected: false
    }
    , {
      name: 'groupStartTime'
      , selected: false
    }
    , {
      name: 'groupEndTime'
      , selected: false
    }
    , {
      name: 'groupRepetitions'
      , selected: false
    }
    , {
      name: 'groupOwner'
      , selected: false
    }
    , {
      name: 'groupOrigin'
      , selected: false
    }
  ];


  defaultSort = {
    fixed: [
      {
        name: 'state'
        , order: 'asc'
      }
    ]
    , user: [
      {
        name: 'name'
        , order: 'asc'
      }
    ]

  }

  filterDevices = [];
  filterDetails = [];

  tracker: TrackerService;

  private clickListener: () => void;
  msg: string="";

  constructor(
    private loginService: LoginService,
    private deviceService: DeviceService,
    private devicecolumnservice: DeviceColumnService,
    private queryParserService: QueryParserService,
    private commonService: CommonService,
    private automationService: AutomationService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private dialog: MatDialog,
    private encryptionDecryptionService: EncryptionDecryptionService,
    private router: Router,
  ) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      console.log('devices array in devices.component.ts', this.devices);
    }, 100);
  }

  ngOnInit() {
    // Initialize selections if previous selections exist
    this.currentUser = this.loginService.currentUserValue;
    if (!this.slaveDevices.length) {
      this.slaveDevices = [];
    }

    this.trackAll();

    this.tracker.trackerEventEmitter.subscribe((data: any) => {
      if (data.type == "add") {
        this.addListener(data.data);
      }
      if (data.type == "change") {
        this.changeListener(data.data);
      }
      if (data.type == "remove") {
        this.removeListener(data.data);
      }
    });
    this.columns = this.defaultColumns
    this.columnDefinitions = this.devicecolumnservice.columnDefinitions


    this.clickListener = this.renderer.listen('document', 'click', (event: MouseEvent) => {
      if (this.showCols) {
        const customizeButton = this.elementRef.nativeElement.querySelector('.btn-primary-outline');
        const dropdownMenu = this.elementRef.nativeElement.querySelector('.dropdown-menu');

        if (customizeButton && dropdownMenu) {
          const isClickInsideButton = customizeButton.contains(event.target);
          const isClickInsideDropdown = dropdownMenu.contains(event.target);

          if (!isClickInsideButton && !isClickInsideDropdown) {
            this.showCols = false;
          }
        }
      }
    });

  }

  update() {
    //this.columns= this.defaultColumns
    this.columns = [...this.columns];
  }

  ngOnDestroy() {
    // this. tracker.removeListener('add',this. addListener)
    // // tracker.removeListener('change', changeListener)
    // // tracker.removeListener('remove', removeListener)
    // this. tracker.removeListener('add',this. changeListener)
    // this. tracker.removeListener('add',this. removeListener)


    if (this.clickListener) {
      this.clickListener();
    }
  }

  trackAll() {
    this.tracker = this.deviceService.trackAll();
  }

  /**
   * Show the master-slave configuration modal
   */
  showMasterSlaveConfiguration(): void {
    // Reset validation message

    this.validationMessage = '';

    // Initialize with current configuration
    this.masterDevice = this.currentConfiguration.master;
    this.slaveDevices = [...this.currentConfiguration.slaves];

    // Ensure we have exactly 4 slots for slaves
    while (this.slaveDevices.length < 4) {
      this.slaveDevices.push(null);
    }

    // Open modal dialog
    this.modalRef = this.dialog.open(this.masterSlaveConfigTemplate, {
      width: '800px',
      disableClose: true,
    });
  }

  /**
   * Get available devices for master selection
   */
  get availableDevices(): any[] {
    // All devices that are not selected as slaves
    return this.devices.filter(device =>
      !this.slaveDevices.some(slave => slave && slave.serial === device.serial)
    );
  }

  /**
   * Get available devices for slave selection at a specific index
   */
  getAvailableSlaveDevices(slaveIndex: number): any[] {
    return this.devices.filter(device => {
      // Device cannot be the master
      if (this.selectedMaster && device.serial === this.selectedMaster.serial) {
        return false;
      }

      // Device cannot be in other slave positions
      for (let i = 0; i < this.slaveDevices.length; i++) {
        if (i !== slaveIndex && this.slaveDevices[i] && this.slaveDevices[i].serial === device.serial) {
          return false;
        }
      }

      return true;
    });
  }

  /**
   * Check if the current configuration is valid
   */
  isConfigurationValid(): boolean {

    // Must have one master
    if (!this.selectedMaster) {
      return false;
    }

    // Must have exactly 4 slaves with no null values
    if (this.slaveDevices.length !== 4 || this.slaveDevices.some(slave => slave === null)) {
      return false;
    }

    // No duplicate selections
    const allIds = [
      this.selectedMaster.serial,
      ...this.slaveDevices.map(slave => slave?.serial)
    ];

    return new Set(allIds).size === 5; // Must have 5 unique IDs
  }

  /**
   * Save the master-slave configuration
   */
  saveMasterSlaveConfiguration(): void {
    // Validate configuration
    if (!this.selectedMaster) {
      this.validationMessage = 'Please select a master device';
      return;
    }

    const nullSlaves = this.slaveDevices.filter(slave => slave === null);
    if (nullSlaves.length > 0) {
      this.validationMessage = 'Please select all 4 slave devices';
      return;
    }

    // All validations passed, update the configuration
    this.currentConfiguration = {
      master: this.selectedMaster,
      slaves: this.slaveDevices as any[] // Type assertion is safe here as we've validated no nulls
    };

    // Save the configuration (would typically call a service)
    this.saveConfiguration();

    // Close the modal
    this.modalRef.close();
  }

  /**
   * Save configuration to backend
   */
  private saveConfiguration(): void {
    let slavesSerials: any[] = [];
    this.currentConfiguration.slaves.forEach((slave) => {
      slavesSerials.push(slave.serial);
    });
    // Here you would typically call a service to save the configuration
    sessionStorage.setItem('masterDevice', this.currentConfiguration.master.serial);
    sessionStorage.setItem('slaveDevices', this.encryptionDecryptionService.encryptDeviceSerials(slavesSerials));
    sessionStorage.setItem('packageName', this.packageName);
  }

  selectMasterDevice(device: any): void {
    if(device.enhancedStateAction !== 'Use'){
      this.openAlertMod(this.alertTemplate, "Please select a device that is in 'Use' state as master device.");
      return;
    }
    console.log('Selected master device:', device.model || device.serial);
    this.automationService.validationUsersAsPerGroupMaster(this.currentUser.userObj.groups.subscribed[0], device.serial);
    // this.router.navigate(['/control', device.serial, 'slave-selection']);
  }

  Launch() {
    let masterDevice = sessionStorage.getItem('masterDevice');
    let slaveDevices = sessionStorage.getItem('slaveDevices');
    this.commonService.setActiveTab('/control/');
    this.router.navigate(['/control', masterDevice, 'multi-execution', slaveDevices]);
  }


  addListener(device) {
    this.devices.push(device);
    let stats = this.updateStats(device)

    this.totalDeviceCount += 1
    this.usableDeviceCount += stats.usable
    this.busyDeviceCount += stats.busy
    this.currentUserUsingDevice += stats.using

    localStorage.setItem('userUsing', this.currentUserUsingDevice);

    this.commonService.setDataObject(this.currentUserUsingDevice)
    // this.dataChange.emit(this.currentUserUsingDevice)
  }

  // updateStats(device) {
  //   return (this.mapping[device.serial] = {
  //     usable: device.usable ? 1 : 0
  //     , busy: device.owner ? 1 : 0
  //     , using: device.using ? 1 : 0
  //   })
  // }
  updateStats(device) {
    const email = this.currentUser?.email ?? null;

    const isCurrentUserDevice =
      device.using === true &&
      device.owner &&
      device.owner.email === email;

    return (this.mapping[device.serial] = {
      usable: device.usable ? 1 : 0,
      busy: device.owner ? 1 : 0,
      using: isCurrentUserDevice ? 1 : 0
    });
  }

  changeListener(device) {
    let oldStats = this.mapping[device.serial]
    let newStats = this.updateStats(device)
    let diffs = Object.create(null)

    this.usableDeviceCount += diffs.usable = newStats.usable - oldStats.usable
    this.busyDeviceCount += diffs.busy = newStats.busy - oldStats.busy
    this.currentUserUsingDevice += diffs.using = newStats.using - oldStats.using

    localStorage.setItem('userUsing', this.currentUserUsingDevice);
    this.commonService.setDataObject(this.currentUserUsingDevice)

    // this.dataChange.emit(this.currentUserUsingDevice)

  }

  removeListener(device) {
    let oldStats = this.mapping[device.serial]
    let newStats = this.updateStats(device)

    this.totalDeviceCount -= 1
    this.usableDeviceCount -= newStats.usable
    this.busyDeviceCount -= newStats.busy
    this.currentUserUsingDevice -= newStats.using

    delete this.mapping[device.serial]

    localStorage.setItem('userUsing', this.currentUserUsingDevice);
    // this.dataChange.emit(this.currentUserUsingDevice)
    this.commonService.setDataObject(this.currentUserUsingDevice)


  }


  setActiveTab(tab: string) {
    this.activeTab = tab;
    this.showCols = false;
  }

  showColumns() {

    this.showCols = !this.showCols;
  }

  applyFilterDetails(query) {
    this.filterDetails = this.queryParserService.parse(query)
  }

  applyFilterDevices(query) {
    const value = 'name:' + query;
    this.filterDevices = this.queryParserService.parse(value);
  }

  reset() {
    // window.location.reload()
    // this.search.deviceFilter = ''
    // this.filter = []
    // // this.sort = this.defaultSort
    this.columns = [
      {
        name: 'state'
        , selected: true
      }
      , {
        name: 'model'
        , selected: true
      }
      , {
        name: 'name'
        , selected: true
      }
      , {
        name: 'serial'
        , selected: true
      }
      , {
        name: 'operator'
        , selected: false
      }
      , {
        name: 'releasedAt'
        , selected: false
      }
      , {
        name: 'version'
        , selected: true
      }
      , {
        name: 'network'
        , selected: false
      }
      , {
        name: 'display'
        , selected: false
      }
      , {
        name: 'manufacturer'
        , selected: false
      }
      , {
        name: 'marketName'
        , selected: false
      }
      , {
        name: 'sdk'
        , selected: false
      }
      , {
        name: 'abi'
        , selected: false
      }
      , {
        name: 'cpuPlatform'
        , selected: false
      }
      , {
        name: 'openGLESVersion'
        , selected: false
      }
      , {
        name: 'browser'
        , selected: false
      }
      , {
        name: 'phone'
        , selected: false
      }
      , {
        name: 'imei'
        , selected: false
      }
      , {
        name: 'imsi'
        , selected: false
      }
      , {
        name: 'iccid'
        , selected: false
      }
      , {
        name: 'batteryHealth'
        , selected: false
      }
      , {
        name: 'batterySource'
        , selected: false
      }
      , {
        name: 'batteryStatus'
        , selected: false
      }
      , {
        name: 'batteryLevel'
        , selected: true
      }
      , {
        name: 'batteryTemp'
        , selected: false
      }
      , {
        name: 'provider'
        , selected: true
      }
      , {
        name: 'notes'
        , selected: true
      }
      , {
        name: 'owner'
        , selected: true
      }
      , {
        name: 'group'
        , selected: true
      }
      , {
        name: 'groupSchedule'
        , selected: false
      }
      , {
        name: 'groupStartTime'
        , selected: false
      }
      , {
        name: 'groupEndTime'
        , selected: false
      }
      , {
        name: 'groupRepetitions'
        , selected: false
      }
      , {
        name: 'groupOwner'
        , selected: false
      }
      , {
        name: 'groupOrigin'
        , selected: false
      }
    ];
    this.columnDefinitions = this.devicecolumnservice.columnDefinitions;
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = "";
    }, 1500)
  }

  Ok(){
    this.modalRef.close();
  }

  changePassword() {
    if (this.newPassword === this.confirmPassword) {
      alert('Password successfully changed!');
      this.oldPassword = '';
      this.newPassword = '';
      this.confirmPassword = '';
    } else {
      alert('New password and confirm password do not match!');
    }
  }
}

